import styles from '@/components/static/StudyMaterialsGuidePage/GuideComponents/BaseGuideComponent/BaseGuideComponent.module.scss'
import { reusableCssClass } from '@/utils/reusableCssClasses'
import React, { ReactElement } from 'react'

interface BaseGuideComponentNoImageProps {
    text: ReactElement
}
export const BaseGuideComponentNoImage: React.FC<
    BaseGuideComponentNoImageProps
> = (props): ReactElement => {
    return (
        <div className={styles.guideComponentContainer}>
            <div className={styles.widthLimitedContainer}>
                <div className={`${reusableCssClass.centerChildrenVertically}`}>
                    {props.text}
                </div>
            </div>
        </div>
    )
}
